import apis from "./index";

// Convert File to base64
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      resolve(result?.split(',')[1] || ''); // strip data:...;base64,
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

// WebSocket-based batch run - streams output and supports interactive prompts
export const runBatchWebSocket = (csvFile, badgeFile, token, callbacks) => {
  const wsUrl = apis.batchIssuing.wsUrl;
  const ws = new WebSocket(wsUrl);

  ws.onopen = async () => {
    try {
      const csvBase64 = await fileToBase64(csvFile);
      const badgeBase64 = await fileToBase64(badgeFile);
      ws.send(JSON.stringify({
        action: 'start',
        csvBase64,
        csvName: csvFile.name,
        badgeBase64,
        badgeName: badgeFile.name,
        token: token.trim()
      }));
    } catch (e) {
      callbacks?.onError?.(e.message);
      ws.close();
    }
  };

  ws.onmessage = (event) => {
    try {
      const msg = JSON.parse(event.data);
      if (msg.type === 'output') callbacks?.onOutput?.(msg.text);
      if (msg.type === 'prompt') callbacks?.onPrompt?.(msg);
      if (msg.type === 'done') callbacks?.onDone?.(msg.code, msg.qrCodeBase64, msg.qrcodes);
      if (msg.type === 'error') callbacks?.onError?.(msg.text);
    } catch (e) {
      callbacks?.onError?.(e.message);
    }
  };

  ws.onerror = () => callbacks?.onError?.('WebSocket error');
  ws.onclose = () => callbacks?.onClose?.();

  const sendInput = (promptId, value) => {
    if (ws.readyState === 1) { // WebSocket.OPEN
      ws.send(JSON.stringify({ action: 'input', promptId, value }));
    }
  };

  return { ws, sendInput };
};

// HTTP fallback (may hang on interactive prompts)
export const runBatch = async (formData, token) => {
  const url = apis.batchIssuing.runBatch;
  console.log("[runBatch] POST", url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[runBatch] HTTP error:", response.status, errorText);
      throw new Error(errorText || `Batch run failed (${response.status})`);
    }

    return await response.text();
  } catch (e) {
    console.error("[runBatch] Error:", e.message);
    if (e.message === 'Failed to fetch') {
      throw new Error('Failed to fetch. Ensure the backend is running at ' + url + ' and CORS is enabled.');
    }
    throw e;
  }
};

// Get QR & Deeplink Details by Email
export const getBatchIssueByEmail = async (email, token) => {
  const url = `${apis.batchIssuing.byEmail}?email=${encodeURIComponent(email)}`;
  console.log("[getBatchIssueByEmail] GET", url);

  try {
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[getBatchIssueByEmail] HTTP error:", response.status, errorText);
      throw new Error(errorText || `Failed to fetch QR details (${response.status})`);
    }

    return await response.json();
  } catch (e) {
    console.error("[getBatchIssueByEmail] Error:", e.message);
    throw e;
  }
};
